import React from 'react';
import useFetchPublicApiKey from './utils/fetchPublicKey';

import "./assets/css/util.scss"
import "./styles/layout.scss"
import "./styles/my.scss"

/**
 * Flatpickr's stylesheet, loaded once for the whole app.
 *
 * Every date field in the app is a flatpickr, and the calendar it appends to
 * <body> is unusable without this: unstyled, it never hides, sits in normal
 * flow at the foot of the page, and renders its month-nav arrows at their
 * natural size — the giant black chevrons that showed up under HES > Push Data.
 *
 * It used to arrive as a side effect of one screen importing it, which meant
 * every picker in the app depended on that screen staying in the bundle. It
 * belongs here instead.
 */
import "flatpickr/dist/themes/light.css"
// import "./styles/style/scss/core.scss"
import Router from './router/Router';

const App = () => {
  if (window.location.hash === "#/login") {
    // dispatch(setSessionData())
    // dispatch(setPublicKey())
    // localStorage.clear();
  }
  // useFetchPublicApiKey()
  const DisbaleConsole = () => {

    if (window.location.origin !== "https://avdhaan.gas.polarisgrids.com") {
      return;
    }

    let logging = null;

    if (typeof localStorage != 'undefined' && typeof Storage !== 'undefined' && localStorage) {
      logging = localStorage.getItem('logging');
    }
    if (logging == null) {
      window.console.log = function () { };   // disable any console.log debugging statements 
      // window.console.error = function () { } // disable any console.error 
    }
  }

  DisbaleConsole()
  return (

    // <HashRouter>
    //   <Routes>
    //     <Route path="/" element={<Login />} />
    //     {/* <Route
    //       path="utility/sbpdcl/hes"
    //       element={<LayoutWrapper children={<SBPDCLUtility />} />}
    //     /> */}
    //     {/* <Route path="/" element={<div></div>} /> */}

    //     <Route
    //       path="utility/lpdd/hes"
    //       element={<LayoutWrapper children={<LPDDUtility />} />}
    //     />
    //     {/* {/* <Route
    //       path="utility/sbpdcl/hes"
    //       element={<LayoutWrapper children={<HesUtility />} />}
    //     /> */}

    //     <Route path="forgot-password" element={<ForgotPassword />} />
    //     <Route path="home" element={<Home />} />
    //   </Routes>
    // </HashRouter>
    <Router />
  );
};

export default App;
